/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    pre: "pre",
    blockquote: "blockquote",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "useTheme"
      }), "(", _jsx(_components.code, {
        children: "useTheme"
      }), ")"]
    }), "\n", _jsx(_components.p, {
      children: "| v5"
    }), "\n", _jsxs(_components.p, {
      children: ["这是一个自定义钩子，用于从 ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), " 获取当前主题。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is a custom hook to get the current theme from a ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { useTheme } from 'styled-components'\n\nfunction MyComponent() {\n  const theme = useTheme()\n  console.log('Current theme: ', theme)\n\n  // ...\n}\n"
      })
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["所有样式组件 ", _jsx(_components.a, {
          href: "/docs/advanced#theming",
          children: "自动接收主题作为属性"
        }), "，因此仅当你出于其他原因希望访问主题时才需要这样做。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥All styled components ", _jsx(_components.a, {
          href: "/docs/advanced#theming",
          children: "automatically receive the theme as a prop"
        }), ", so this is only necessary if you wish to access the theme for other reasons."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
